import { render, staticRenderFns } from "./AuthedCompanies.vue?vue&type=template&id=12f2af6a&"
import script from "./AuthedCompanies.vue?vue&type=script&lang=js&"
export * from "./AuthedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./AuthedCompanies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports